import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Input from "../../../../components/elements/form/input";
import Teaxtarea from "../../../../components/elements/form/textarea";
import SelectBox from "../../../../components/elements/form/selectBox";
import { DropdownOptionType, Option } from "../../../../_config/types";
import Datepicker from "../../../../components/elements/form/datepicker";
import Button from "../../../../components/elements/button";
import mapImg from "../../../../images/map-left.jpg";
import qrImg from "../../../../images/facility-qr.jpg";
import partsImg from "../../../../images/parts-pic.jpg";
import Icon from "../../../../components/icons";
import { useFacilitiesApi } from "../../../../store/api/hooks/facilitiesApiHook";
import toast from "react-hot-toast";
import { useSpearPartsApi } from "../../../../store/api/hooks/spearPartsApiHook";
import { useFacilityManagersSelector } from "../../../../store/selectors/masterSelector";
import { useCommonApi } from "../../../../store/api/hooks/commonApiHook";
import { useCycleCountApi } from "../../../../store/api/hooks/cycleCountApiHook";
import { count } from "console";

interface Props {
	_ref?: any;
	editData?: any;
	onCreate?: () => void;
	onCancel?: () => void;
}
type FormValues = {
	cycleCountNotes: string;
	operatorID: any;
	assetType: string;
	purchaseDate: Date | null;
	facilityID: any;
	subFacilityID: any;
};

const CreateCycleCount: React.FC<Props> = ({
	_ref,
	editData,
	onCreate = () => { },
	onCancel = () => { },
}) => {
	const [facilityoption, setFacilityoption] = useState<any>([]);
	const [subfacilitylist, setsubfacilityoption] = useState<any>([]);
	const [cycleCountCode, setCycleCountCode] = useState<any>(null);
	const [partstatus, setPartStatus] = useState<boolean>(false);
	const [parts, setParts] = useState<any>([]);
	const facilityApi: any = useFacilitiesApi();
	const commonApi: any = useCommonApi();
	const spearPartsAPI = useSpearPartsApi();
	const cycleCountAPI = useCycleCountApi();

	const {
		control,
		register,
		handleSubmit,
		setValue,
		reset,
		trigger,
		formState: { errors },
		watch,
	} = useForm<FormValues>();
	const users = useFacilityManagersSelector();
	const facilityWatch = watch("facilityID");

	const getfacilitylist = () => {
		const payload = {};
		facilityApi.getFacilityList(
			payload,
			(resp: any) => {
				let facilitylist: any = [];
				resp.facilityList.map((facilist: any) => {
					facilitylist.push({
						label: facilist.facilityName,
						value: facilist.facilityID,
						data: facilist,
					});
				});
				setFacilityoption(facilitylist);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	const getsubfacilityList = (_facilityID: any) => {
		const payload = { facilityID: _facilityID };
		facilityApi.getSubFacilityList(
			payload,
			(resp: any) => {
				let subfacilityoption: any = resp?.subFacilityList?.map(
					(countylist: any) => {
						return {
							label: `${countylist.subFacilityTypeName} - ${countylist.no}`,
							value: countylist.subFacilityID,
						};
					}
				);

				setsubfacilityoption(subfacilityoption);
				// if (editData) {
				//     console.log('..............', getSelectedOption(editData.subFacilityID, subfacilityoption))
				//     setValue("subFacilityID", getSelectedOption(editData.subFacilityID, subfacilityoption));
				// }
			},
			(error: any) => {
				console.log("error =>", error);
				setsubfacilityoption([]);
				toast.error(error);
			}
		);
	};

	const getCycleCountCode = () => {
		const payload = {};
		cycleCountAPI.GetID(
			payload,
			(resp: any) => {

				setCycleCountCode(resp.code);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	useEffect(() => {
		if (users == null) {
			commonApi.GetUserList(
				{
					pageNo: 1,
					pageSize: 1000,
				},
				(resp: any) => { },
				(error: any) => { }
			);
		}
	}, [users]);

	useEffect(() => {
		if (facilityWatch) {
			setValue("subFacilityID", null);
			getsubfacilityList(facilityWatch.value);
		}
	}, [facilityWatch]);

	const formReset = () => {
		reset({
			cycleCountNotes: '',
			operatorID: '',
			assetType: '',
			purchaseDate: null,
			facilityID: '',
			subFacilityID: ''

		});
		setParts([])
		setPartStatus(false)
	};

	useEffect(() => {
		if (_ref?.current) {
			_ref.current.reset = formReset;
		}
	}, [_ref]);

	const onSubmit: SubmitHandler<FormValues> = (data) => {

		let cyclecnt: any = [];
		parts.map((part: any) => {

			cyclecnt.push({
				"partsID": part.partDetails.partsID,
				"systemQuantity": part.currentStock,
				"countedQuantity": part.qty,
				"partsCostRate": part.partDetails.costPerUnit,
				"unitID": part.partDetails.unitID,
				"isDraft": false
			})

		})

		let payload = {

			"inventoryCycleCountCode": cycleCountCode,
			"operatorID": data.operatorID?.value,
			"facilityID": data.facilityID?.value,
			"subFacilityID": data.subFacilityID?.value,
			"countingDate": data?.purchaseDate,
			"cycleCountNotes": data.cycleCountNotes,
			"isDraft": false,
			"cycleCountDetails": cyclecnt
		}
		//console.log("fsfsfsfsfsff1",payload)
		cycleCountAPI.Save(
			payload,
			(resp: any) => {
				onCreate();
				formReset();
				toast.success("Cycle count Saved Successfully")
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	useEffect(() => {
		getCycleCountCode()
		getfacilitylist();

	}, []);

	return (
		<form onSubmit={handleSubmit(onSubmit)} ref={_ref} >
			<div className="pt-4">
				<div className="bg-green-50 py-2 px-3">
					<h6 className="text-[0.813rem] font-semibold">Cycle Count Ref No</h6>
					<p className="text-[0.813rem] font-normal mt-2">{cycleCountCode}</p>
				</div>
				<div className="grid grid-cols-2 gap-2">
					<Controller
						name="facilityID"
						control={control}
						rules={{ required: "Facility is required" }}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label="Select Facility"
								value={value}
								disabled={partstatus}
								onChange={onChange}
								required
								placeholder="Choose Facility"
								options={facilityoption}
								className="mb-0"
								error={errors.facilityID?.message as any}
							/>
						)}
					/>
					<Controller
						name="subFacilityID"
						control={control}
						//  rules={{ required: "SubFacility is required" }}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label="Select Sub Facility"
								value={value}
								disabled={partstatus}
								onChange={onChange}
								//   required
								placeholder="Choose Sub Facility"
								options={subfacilitylist}
								className="mb-0"
							/>
						)}
					/>
				</div>
			</div>
			<Controller
				name="purchaseDate"
				control={control}
				render={({ field: { value, onChange } }) => (
					<Datepicker
						disabled={partstatus}
						label="Date"
						value={value}
						onChange={onChange}
						className="mt-3"
					/>
				)}
			/>
			<Controller
				name="operatorID"
				control={control}
				render={({ field: { value, onChange } }) => (
					<SelectBox
						label="Operator Name"
						value={value}
						onChange={onChange}
						disabled={partstatus}

						placeholder="Operator Name"
						options={users ? users : []}
					/>
				)}
			/>
			<Button
				onClick={() => {
					trigger(['facilityID']).then((valid: boolean) => {
						if (valid) {
							setPartStatus(true);
						}


					})

				}}
			>
				Start
			</Button>
			{partstatus && (
				<>
					<div>
						<SelectBox
							async={true}
							value={null}
							onChange={(option) => {
								console.log("fdsfsfsfsf", option);
								cycleCountAPI.GetStockCount(
									{
										partID: option.value,
										facilityID: facilityWatch?.value
									},
									(resp: any) => {
										console.log("return arra", resp);

										setParts([
											...parts,
											{
												...option,
												currentStock: resp?.currentStock || null,
											},
										]);
									},
									(error: any) => {
										setParts([...parts, { ...option, currentStock: null }]);
									}
								);
							}}
							placeholder="search part here"
							asyncLoadOptions={(value: string) => {
								return new Promise((resolve, reject) => {
									spearPartsAPI.getSpearPartsList(
										{
											pageSize: 20,
											pageNumber: 1,
											searchKey: value,
										},
										(data: any) => {
											// console.log("Part Data", data)
											resolve(
												data.sparePartsList.map((part: any) => {
													return {
														label: part.sparePartsName + ` (${part.partsCode})`,
														value: part.partsID,
														partDetails: part,
													};
												})
											);
										},
										(error: any) => {
											reject(error);
										}
									);
								});
							}}
						/>
					</div>
					<div className="rounded-md border border-gray-300">
						<div className="grid grid-cols-12 gap-1 bg-gray-100">
							<div className="col-span-3 px-2 leading-10 ">
								<label className="text-[0.75rem] font-medium text-slate-600">
									Part Code
								</label>
							</div>
							<div className="col-span-3 px-2 leading-10">
								<label className="text-[0.75rem] font-medium text-slate-600">
									Part Name
								</label>
							</div>
							<div className="col-span-3 px-2 leading-10">
								<label className="text-[0.75rem] font-medium text-slate-600">
									System Qty
								</label>
							</div>
							<div className="col-span-3 px-2 leading-10">
								<label className="text-[0.75rem] font-medium text-slate-600">
									Counted Qty
								</label>
							</div>
						</div>
						{parts.map((part: any, index: any) => (
							<div
								className="grid grid-cols-12 gap-1 text-slate-800"
								key={part.id}
							>
								<div className="col-span-3 px-2 leading-10 flex items-center">
									{part?.partDetails?.partsCode}
								</div>
								<div className="col-span-3 px-2 leading-10 flex items-center">
									<label className="text-[0.75rem] font-normal">
										{part?.partDetails?.sparePartsName}
									</label>
								</div>
								<div className="col-span-3 px-2 leading-10 flex items-center">
									<label className="text-[0.75rem] font-normal text-center w-full">
										{part?.currentStock}
									</label>
								</div>
								<div className="col-span-3 px-2 leading-10 flex items-center">
									<Input
										size="sm"
										className="!my-0"
										type="number"
										value={part.qty}
										onChange={(e) => {
											setParts(
												parts.map((_part: any) => {
													if (_part.value == part.value) {
														_part.qty = e.target.value;
													}
													return _part;
												})
											);

											//     update(index, {
											//     ...parts[index],
											//      qty: e.target.value ,
											//   })
										}}
									/>
								</div>
							</div>
						))}
					</div>
				</>
			)}

			<Controller
				name="cycleCountNotes"
				control={control}
				render={({ field: { value, onChange } }) => (
					<Teaxtarea
						label="Description"
						value={value}
						onChange={onChange}

						placeholder="Description"
					/>
				)}
			/>
			<div className="flex justify-end gap-2">
				<Button type="submit" disabled={parts.length == 0 ? true : false}>
					Save
				</Button>
				<Button
					theme="secondary"
					onClick={() => {
						onCancel();
						formReset();
					}}
				>
					Cancel
				</Button>
			</div>
		</form>
	);
};

export default CreateCycleCount;
